export class AnagraficaNota
{
  id: number;
  dataCreazione: Date;
  nota: string;
  idAnagrafica: number;
}


// WEBPACK FOOTER //
// /home/david/vscode-workspace/TOP-casa-nel-web/frontend/src/app/models/anagrafica-nota.ts